export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrow-down-blue.2655987f.svg","height":16,"width":12,"blurWidth":0,"blurHeight":0};